import React from 'react';
import AttachmentGridItem from './AttachmentGridItem';
import AttachmentListItem from './AttachmentListItem';
import { type AttachmentProps } from './types';

const Attachment = ({ variant = 'single', theme = 'light', goExperimental = false, ...restProps }: AttachmentProps) => {
  const currentTheme = goExperimental ? 'dark' : theme;
  if (variant === 'list') {
    return <AttachmentListItem {...restProps} variant={variant} theme={currentTheme} />;
  }

  return <AttachmentGridItem {...restProps} variant={variant} theme={currentTheme} />;
};

Attachment.displayName = 'Attachment';
export default Attachment;
